import { ChangeDetectionStrategy, Component, computed, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonModule, CheckboxComponentModule, DIALOG_DATA, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { WalletCardComponent } from '@kr/components';
import { WalletCard } from '@kr/models';

interface WalletEditDialogData {
  wallet: WalletCard;
}

@Component({
  imports: [TranslateModule, IconModule, ButtonModule, WalletCardComponent, CheckboxComponentModule, FormsModule],
  selector: 'kr-wallet-edit',
  templateUrl: './wallet-edit.component.html',
  styleUrls: ['./wallet-edit.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletEditComponent {
  readonly #data = inject<WalletEditDialogData>(DIALOG_DATA);
  readonly #dialogRef = inject(DialogRef);

  wallet = this.#data.wallet;
  walletName = signal(this.wallet.name);
  forDelete = model(false);

  disabledApply = computed(() => !this.forDelete() && this.wallet.name === this.walletName());

  apply(): void {
    if (this.forDelete()) {
      this.#dialogRef.close({ ...this.wallet, isDeleted: true });
    } else {
      this.#dialogRef.close({ ...this.wallet, name: this.walletName() });
    }
  }

  close(): void {
    this.#dialogRef.close();
  }
}
